import Axhelper from '@/lib/Axhelper'

class RozliczeniaService {
	constructor() {
		this.endpoints = {
			trainers: '/api/rozliczenia/trainers',
			trainer: '/api/rozliczenia/trainer',
		}
	}

	async getTrainers(options = {}) {
		try {
			const {
				limit = 50,
				sortColumn = 'nazwa',
				sortDirection = 'asc',
				filters = {},
			} = options

			const params = new URLSearchParams({
				limit: String(limit),
				sortcol: sortColumn,
				sortdir: sortDirection,
			})

			const searchText = `${filters.searchText || ''}`.trim()
			if (searchText) params.set('searchText', searchText)

			const response = await Axhelper.sendGetAsync(`${this.endpoints.trainers}?${params.toString()}`)
			if (response.error) {
				return { data: [], error: response.error, totalCount: 0, hasMore: false }
			}

			const data = Array.isArray(response.data) ? response.data : []
			const totalCount = response.headers?.['x-total-count']
				? parseInt(response.headers['x-total-count'], 10)
				: data.length

			return {
				data,
				error: null,
				totalCount,
				hasMore: data.length < totalCount,
			}
		} catch (error) {
			console.error('RozliczeniaService.getTrainers error:', error)
			return {
				data: [],
				error: error.message || 'Failed to fetch trainers',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	async getTrainerMonth(trainerId, { year, month } = {}) {
		try {
			if (!trainerId) {
				return { data: null, error: 'Invalid trainer ID provided' }
			}

			const params = new URLSearchParams({
				year: String(year),
				month: String(month),
			})
			const url = `${this.endpoints.trainer}/${encodeURIComponent(trainerId)}?${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return { data: null, error: response.error }
			}

			return { data: response.data || null, error: null }
		} catch (error) {
			console.error('RozliczeniaService.getTrainerMonth error:', error)
			return { data: null, error: error.message || 'Failed to fetch settlement' }
		}
	}

	async saveTrainerMonth(trainerId, payload = {}) {
		try {
			if (!trainerId) {
				return { success: false, error: 'Invalid trainer ID provided', data: null }
			}

			const url = `${this.endpoints.trainer}/${encodeURIComponent(trainerId)}`
			const response = await Axhelper.sendPutAsync(url, {
				year: Number(payload.year),
				month: Number(payload.month),
				rozliczono: !!payload.rozliczono,
				entries: Array.isArray(payload.entries) ? payload.entries : [],
				przelewy: Array.isArray(payload.przelewy) ? payload.przelewy : [],
			})

			if (response.error) {
				return { success: false, error: response.error, data: null }
			}

			return { success: true, error: null, data: response.data }
		} catch (error) {
			console.error('RozliczeniaService.saveTrainerMonth error:', error)
			return {
				success: false,
				error: error.message || 'Failed to save settlement',
				data: null,
			}
		}
	}
}

export default new RozliczeniaService()
